import React, { PropsWithChildren } from 'react';
import { Box } from '@mui/material';

type PageContentAreaPropsT = PropsWithChildren<{}>;

function PageContentArea({ children }: PageContentAreaPropsT) {
  return (
    <>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 8,
          pl: 3,
          pr: 3,
        }}
      >
        <Box
          sx={{
            width: '100%',
            // maxWidth: '1280px',
          }}
        >
          {children}
        </Box>
      </Box>
    </>
  );
}

export default PageContentArea;
